import React from 'react';
import SiteLogo from '../../SiteLogo';

const FooterLogo: React.FC = () => {
  return (
    <div className="Footer__logo-wrapper">
      <SiteLogo />
    </div>
  );
};

export default FooterLogo;
